const currency = new Intl.NumberFormat('en-EG', {
  style: 'currency',
  currency: 'EGP',
})
const Currency = (path) => (rowData) =>
  rowData[path] ? currency.format(rowData[path]) : 'EGP 0.00'

export default Currency
